import {charsheetAPI} from '../globals.js';
import axios from 'axios';
import Cookies from "js-cookie";

const uploadImage = async (image, charName, currentCampaign ) => {

      // check to see if this is a new random character
      const cookieCharName = Cookies.get('currentChar')
      if ( charName !== cookieCharName ) {
        alert('Save character before uploading image')
        return;
      }
  
      // if running on localhost, save it to local file system
      if (window.location.hostname === 'localhost') {
        // save as a local .jpg file
        const link = document.createElement('a');
        link.href = URL.createObjectURL(image);
        link.download = `${charName}.jpg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      
          
      // Set up the API call
      const API_URL = `${charsheetAPI}?TableName=image-upload&CharName=${charName}&campaign=${currentCampaign}`;


      // Convert file to base64
      const reader = new FileReader();
      const base64Image = await new Promise((res) => {
            reader.onload = () => res(reader.result.split(',')[1]); // Remove data:image/...;base64, prefix
            reader.readAsDataURL(image);
      });


      // Create payload with base64 encoded image
        const payload = {
          filename: 'not-used-at-this-time.jpg',   // lambda function sets filename to campaign/CharName.jpg
          image: base64Image
        };

        console.log('Uploading image:', payload);


          try {

            const response = await axios({
              host: charsheetAPI,
              method: 'POST',
              url: API_URL,
              headers: { 'content-type': 'text/plain' },
              withCredentials: true,
              data: { ...payload },   // this is the 'body' in AWS
            });

          console.log('Response:', response);

          // Notify view components so the new image appears without a page refresh
          const localURL = URL.createObjectURL(image);
          window.dispatchEvent(new CustomEvent('charImageUpdated', {
            detail: { charName, campaign: currentCampaign, url: localURL }
          }));

          } catch (error) {

            console.error('Error uploading image:', error);
            if (error.response.data === "insufficient user permissions") {
                alert('Access denied. Probably not your character.\n\nIf this is a new character, try saving first');
            } else {
                alert(error.response.data);
            }

          }

}

export default uploadImage